import { gql } from '@apollo/client';

export const SEND_DOCU_SIGN_INSTANT_ALERT = gql`
  mutation Flex_SendDocuSignInstantAlert($input: DocuSignInstantAlertInput!) {
    docusignInstantAlert(input: $input) {
      success
    }
  }
`;
